import { Navigate } from 'react-router-dom';
import { useHospitalManager } from '../hook/useHospitalManager';

const HospitalManagerRoute = ({ component: Component, ...rest }) => {
  const { isHospitalManager, isAdmin, isSuperAdmin, isLoading } = useHospitalManager();
  // console.log("useHospitalManager isHospitalManager:", isHospitalManager);
  // console.log("useHospitalManager isAdmin:", isAdmin);
  // console.log("useHospitalManager isSuperAdmin:", isSuperAdmin);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (isHospitalManager || isAdmin || isSuperAdmin) ? <Component {...rest} /> : <Navigate to="/login" replace />;
};

export default HospitalManagerRoute;